.errorText {
    margin: 0;
    font-size: var(--tempest-text-sm);
    line-height: 1.4;
    color: var(--tempest-danger);
}
